function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["field", "aggregate", "bin", "timeUnit"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { array, isArray } from 'vega-util';
import { isArgmaxDef, isArgminDef } from './aggregate';
import { isBinned, isBinning } from './bin';
import { ANGLE, CHANNELS, COLOR, DESCRIPTION, DETAIL, FILL, FILLOPACITY, getMainChannelFromOffsetChannel, getOffsetScaleChannel, HREF, isChannel, isNonPositionScaleChannel, isSecondaryRangeChannel, isXorY, isXorYOffset, KEY, LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2, OPACITY, ORDER, RADIUS, RADIUS2, SHAPE, SIZE, STROKE, STROKEDASH, STROKEOPACITY, STROKEWIDTH, supportMark, TEXT, THETA, THETA2, TIME, TOOLTIP, UNIT_CHANNELS, URL, X, X2, XOFFSET, Y, Y2, YOFFSET } from './channel';
import { binRequiresRange, getFieldDef, getGuide, hasConditionalFieldDef, hasConditionalFieldOrDatumDef, initChannelDef, initFieldDef, isConditionalDef, isDatumDef, isFieldDef, isOrderOnlyDef, isTypedFieldDef, isValueDef, title, vgField } from './channeldef';
import * as log from './log';
import { isContinuous, isDiscrete, QUANTITATIVE, TEMPORAL } from './type';
import { keys, some } from './util';
import { isSignalRef } from './vega.schema';
import { isBinnedTimeUnit } from './timeunit';
export function channelHasField(encoding, channel) {
  var channelDef = encoding && encoding[channel];
  if (channelDef) {
    if (isArray(channelDef)) {
      return some(channelDef, function (fieldDef) {
        return !!fieldDef.field;
      });
    } else {
      return isFieldDef(channelDef) || hasConditionalFieldDef(channelDef);
    }
  }
  return false;
}
export function channelHasFieldOrDatum(encoding, channel) {
  var channelDef = encoding && encoding[channel];
  if (channelDef) {
    if (isArray(channelDef)) {
      return some(channelDef, function (fieldDef) {
        return !!fieldDef.field;
      });
    } else {
      return isFieldDef(channelDef) || isDatumDef(channelDef) || hasConditionalFieldOrDatumDef(channelDef);
    }
  }
  return false;
}
export function channelHasNestedOffsetScale(encoding, channel) {
  if (isXorY(channel)) {
    var fieldDef = encoding[channel];
    if ((isFieldDef(fieldDef) || isDatumDef(fieldDef)) && (isDiscrete(fieldDef.type) || isFieldDef(fieldDef) && fieldDef.timeUnit)) {
      var offsetChannel = getOffsetScaleChannel(channel);
      return channelHasFieldOrDatum(encoding, offsetChannel);
    }
  }
  return false;
}
export function isAggregate(encoding) {
  return some(CHANNELS, function (channel) {
    if (channelHasField(encoding, channel)) {
      var channelDef = encoding[channel];
      if (isArray(channelDef)) {
        return some(channelDef, function (fieldDef) {
          return !!fieldDef.aggregate;
        });
      } else {
        var fieldDef = getFieldDef(channelDef);
        return fieldDef && !!fieldDef.aggregate;
      }
    }
    return false;
  });
}
export function extractTransformsFromEncoding(oldEncoding, config) {
  var groupby = [];
  var bins = [];
  var timeUnits = [];
  var aggregate = [];
  var encoding = {};
  forEach(oldEncoding, function (channelDef, channel) {
    // Extract potential embedded transformations along with remaining properties
    if (isFieldDef(channelDef)) {
      var field = channelDef.field,
        aggOp = channelDef.aggregate,
        bin = channelDef.bin,
        timeUnit = channelDef.timeUnit,
        remaining = _objectWithoutProperties(channelDef, _excluded);
      if (aggOp || timeUnit || bin) {
        var guide = getGuide(channelDef);
        var isTitleDefined = guide === null || guide === void 0 ? void 0 : guide.title;
        var newField = vgField(channelDef, {
          forAs: true
        });
        var newFieldDef = _objectSpread(_objectSpread(_objectSpread({}, isTitleDefined ? [] : {
          title: title(channelDef, config, {
            allowDisabling: true
          })
        }), remaining), {}, {
          // Always overwrite field
          field: newField
        });
        if (aggOp) {
          var op;
          if (isArgmaxDef(aggOp)) {
            op = 'argmax';
            newField = vgField({
              op: 'argmax',
              field: aggOp.argmax
            }, {
              forAs: true
            });
            newFieldDef.field = "".concat(newField, ".").concat(field);
          } else if (isArgminDef(aggOp)) {
            op = 'argmin';
            newField = vgField({
              op: 'argmin',
              field: aggOp.argmin
            }, {
              forAs: true
            });
            newFieldDef.field = "".concat(newField, ".").concat(field);
          } else if (aggOp !== 'boxplot' && aggOp !== 'errorbar' && aggOp !== 'errorband') {
            op = aggOp;
          }
          if (op) {
            var aggregateEntry = {
              op: op,
              as: newField
            };
            if (field) {
              aggregateEntry.field = field;
            }
            aggregate.push(aggregateEntry);
          }
        } else {
          groupby.push(newField);
          if (isTypedFieldDef(channelDef) && isBinning(bin)) {
            bins.push({
              bin: bin,
              field: field,
              as: newField
            });
            // Add additional groupbys for range and end of bins
            groupby.push(vgField(channelDef, {
              binSuffix: 'end'
            }));
            if (binRequiresRange(channelDef, channel)) {
              groupby.push(vgField(channelDef, {
                binSuffix: 'range'
              }));
            }
            // Create accompanying 'x2' or 'y2' field if channel is 'x' or 'y' respectively
            if (isXorY(channel)) {
              var secondaryChannel = {
                field: "".concat(newField, "_end")
              };
              encoding["".concat(channel, "2")] = secondaryChannel;
            }
            newFieldDef.bin = 'binned';
            if (!isSecondaryRangeChannel(channel)) {
              newFieldDef['type'] = QUANTITATIVE;
            }
          } else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
            timeUnits.push({
              timeUnit: timeUnit,
              field: field,
              as: newField
            });
            // define the format type for later compilation
            var formatType = isTypedFieldDef(channelDef) && channelDef.type !== TEMPORAL && 'time';
            if (formatType) {
              if (channel === TEXT || channel === TOOLTIP) {
                newFieldDef['formatType'] = formatType;
              } else if (isNonPositionScaleChannel(channel)) {
                newFieldDef['legend'] = _objectSpread({
                  formatType: formatType
                }, newFieldDef['legend']);
              } else if (isXorY(channel)) {
                newFieldDef['axis'] = _objectSpread({
                  formatType: formatType
                }, newFieldDef['axis']);
              }
            }
          }
        }
        // now the field should refer to post-transformed field instead
        encoding[channel] = newFieldDef;
      } else {
        groupby.push(field);
        encoding[channel] = oldEncoding[channel];
      }
    } else {
      // For value def / signal ref / datum def, just copy
      encoding[channel] = oldEncoding[channel];
    }
  });
  return {
    bins: bins,
    timeUnits: timeUnits,
    aggregate: aggregate,
    groupby: groupby,
    encoding: encoding
  };
}
export function markChannelCompatible(encoding, channel, mark) {
  var markSupported = supportMark(channel, mark);
  if (!markSupported) {
    return false;
  } else if (markSupported === 'binned') {
    var primaryFieldDef = encoding[channel === X2 ? X : Y];
    // circle, point, square and tick only support x2/y2 when their corresponding x/y fieldDef
    // has "binned" data and thus need x2/y2 to specify the bin-end field.
    if (isFieldDef(primaryFieldDef) && isFieldDef(encoding[channel]) && isBinned(primaryFieldDef.bin)) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}
export function initEncoding(encoding, mark, filled, config) {
  var normalizedEncoding = {};
  var _iterator = _createForOfIteratorHelper(keys(encoding)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (!isChannel(key)) {
        // Drop invalid channel
        log.warn(log.message.invalidEncodingChannel(key));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(UNIT_CHANNELS),
    _step2;
  try {
    var _loop = function _loop() {
        var channel = _step2.value;
        if (!encoding[channel]) {
          return 0; // continue
        }
        var channelDef = encoding[channel];
        if (isXorYOffset(channel)) {
          var mainChannel = getMainChannelFromOffsetChannel(channel);
          var positionDef = normalizedEncoding[mainChannel];
          if (isFieldDef(positionDef)) {
            if (isContinuous(positionDef.type)) {
              if (isFieldDef(channelDef) && !positionDef.timeUnit) {
                // TODO: nesting continuous field instead continuous field should
                // behave like offsetting the data in data domain
                log.warn(log.message.offsetNestedInsideContinuousPositionScaleDropped(mainChannel));
                return 0; // continue
              }
            }
          }
        }
        if (channel === 'angle' && mark === 'arc' && !encoding.theta) {
          log.warn(log.message.REPLACE_ANGLE_WITH_THETA);
          channel = THETA;
        }
        if (!markChannelCompatible(encoding, channel, mark)) {
          // Drop unsupported channel
          log.warn(log.message.incompatibleChannel(channel, mark));
          return 0; // continue
        }
        // Drop line's size if the field is aggregated.
        if (channel === SIZE && mark === 'line') {
          var fieldDef = getFieldDef(encoding[channel]);
          if (fieldDef !== null && fieldDef !== void 0 && fieldDef.aggregate) {
            log.warn(log.message.LINE_WITH_VARYING_SIZE);
            return 0; // continue
          }
        }
        // Drop color if either fill or stroke is specified
        if (channel === COLOR && (filled ? 'fill' in encoding : 'stroke' in encoding)) {
          log.warn(log.message.droppingColor('encoding', {
            fill: 'fill' in encoding,
            stroke: 'stroke' in encoding
          }));
          return 0; // continue
        }
        if (channel === DETAIL || channel === ORDER && !isArray(channelDef) && !isValueDef(channelDef) || channel === TOOLTIP && isArray(channelDef)) {
          if (channelDef) {
            if (channel === ORDER) {
              var def = encoding[channel];
              if (isOrderOnlyDef(def)) {
                normalizedEncoding[channel] = def;
                return 0; // continue
              }
            }
            // Array of fieldDefs for detail channel (or production rule)
            normalizedEncoding[channel] = array(channelDef).reduce(function (defs, fieldDef) {
              if (!isFieldDef(fieldDef)) {
                log.warn(log.message.emptyFieldDef(fieldDef, channel));
              } else {
                defs.push(initFieldDef(fieldDef, channel));
              }
              return defs;
            }, []);
          }
        } else {
          if (channel === TOOLTIP && channelDef === null) {
            // Preserve null so we can use it to disable tooltip
            normalizedEncoding[channel] = null;
          } else if (!isFieldDef(channelDef) && !isDatumDef(channelDef) && !isValueDef(channelDef) && !isConditionalDef(channelDef) && !isSignalRef(channelDef)) {
            log.warn(log.message.emptyFieldDef(channelDef, channel));
            return 0; // continue
          }
          normalizedEncoding[channel] = initChannelDef(channelDef, channel, config);
        }
      },
      _ret;
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return normalizedEncoding;
}
/**
 * For composite marks, we have to call initChannelDef during init so we can infer types earlier.
 */
export function normalizeEncoding(encoding, config) {
  var normalizedEncoding = {};
  var _iterator3 = _createForOfIteratorHelper(keys(encoding)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var channel = _step3.value;
      var newChannelDef = initChannelDef(encoding[channel], channel, config, {
        compositeMark: true
      });
      normalizedEncoding[channel] = newChannelDef;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return normalizedEncoding;
}
export function fieldDefs(encoding) {
  var arr = [];
  var _iterator4 = _createForOfIteratorHelper(keys(encoding)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var channel = _step4.value;
      if (channelHasField(encoding, channel)) {
        var channelDef = encoding[channel];
        var channelDefArray = array(channelDef);
        var _iterator5 = _createForOfIteratorHelper(channelDefArray),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var def = _step5.value;
            if (isFieldDef(def)) {
              arr.push(def);
            } else if (hasConditionalFieldDef(def)) {
              arr.push(def.condition);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return arr;
}
export function forEach(mapping, f, thisArg) {
  if (!mapping) {
    return;
  }
  var _iterator6 = _createForOfIteratorHelper(keys(mapping)),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var channel = _step6.value;
      var el = mapping[channel];
      if (isArray(el)) {
        var _iterator7 = _createForOfIteratorHelper(el),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var channelDef = _step7.value;
            f.call(thisArg, channelDef, channel);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      } else {
        f.call(thisArg, el, channel);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}
export function reduce(mapping, f, init, thisArg) {
  if (!mapping) {
    return init;
  }
  return keys(mapping).reduce(function (r, channel) {
    var map = mapping[channel];
    if (isArray(map)) {
      return map.reduce(function (r1, channelDef) {
        return f.call(thisArg, r1, channelDef, channel);
      }, r);
    } else {
      return f.call(thisArg, r, map, channel);
    }
  }, init);
}
/**
 * Returns list of path grouping fields for the given encoding
 */
export function pathGroupingFields(mark, encoding) {
  return keys(encoding).reduce(function (details, channel) {
    switch (channel) {
      // x, y, x2, y2, lat, long, lat1, long2, order, tooltip, href, aria label, cursor should not cause lines to group
      case X:
      case Y:
      case HREF:
      case DESCRIPTION:
      case URL:
      case X2:
      case Y2:
      case XOFFSET:
      case YOFFSET:
      case THETA:
      case THETA2:
      case RADIUS:
      case RADIUS2:
      case TIME:
      // falls through
      case LATITUDE:
      case LONGITUDE:
      case LATITUDE2:
      case LONGITUDE2:
      // TODO: case 'cursor':
      // text, shape, shouldn't be a part of line/trail/area [falls through]
      case TEXT:
      case SHAPE:
      case ANGLE:
      // falls through
      // tooltip fields should not be added to group by [falls through]
      case TOOLTIP:
        return details;
      case ORDER:
        // order should not group line / trail
        if (mark === 'line' || mark === 'trail') {
          return details;
        }
      // but order should group area for stacking (falls through)
      case DETAIL:
      case KEY:
        {
          var channelDef = encoding[channel];
          if (isArray(channelDef) || isFieldDef(channelDef)) {
            var _iterator8 = _createForOfIteratorHelper(array(channelDef)),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var fieldDef = _step8.value;
                if (!fieldDef.aggregate) {
                  details.push(vgField(fieldDef, {}));
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
          return details;
        }
      case SIZE:
        if (mark === 'trail') {
          // For trail, size should not group trail lines.
          return details;
        }
      // For line, size should group lines.
      // falls through
      case COLOR:
      case FILL:
      case STROKE:
      case OPACITY:
      case FILLOPACITY:
      case STROKEOPACITY:
      case STROKEDASH:
      case STROKEWIDTH:
        {
          // TODO strokeDashOffset:
          // falls through
          var _fieldDef = getFieldDef(encoding[channel]);
          if (_fieldDef && !_fieldDef.aggregate) {
            details.push(vgField(_fieldDef, {}));
          }
          return details;
        }
    }
  }, []);
}